export const ProjectPlanRouting = [
  {
    path: "/work-manage/project-plan/list",
    name: "work-manage-project-plan-list",
    meta: { title: "施工计划" },
    notice: { type: "project_work_plan_examine", hasNotice: false },
    component: () => import("@/views/work-manage/project-plan/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-plan/create",
    name: "work-manage-project-plan-create",
    meta: { title: "新增施工计划", comName: "WorkManageProjectPlanFormCreate" },
    component: () => import("@/views/work-manage/project-plan/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-plan/edit/:id",
    name: "work-manage-project-plan-edit",
    meta: { title: "编辑施工计划", comName: "WorkManageProjectPlanFormCreate" },
    component: () => import("@/views/work-manage/project-plan/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-plan/detail/:id",
    name: "work-manage-project-plan-detail",
    meta: { title: "施工计划详情" },
    component: () => import("@/views/work-manage/project-plan/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-plan/flowPrint/:id",
    name: "work-manage-project-plan-edit-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/project-plan/form-print/index.vue"),
  },
];
